<template>
<b-container>
        <b-card v-if="orgCode === null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name: 'ward-organizations', params: { 'wardId': wardId}}"> Ward Organizations</b-breadcrumb-item>
            <b-breadcrumb-item active>Create Organization</b-breadcrumb-item>
        </b-breadcrumb>
        <h4>Create a new Organization/Group.</h4>
        </b-card>
        <b-card v-if="orgCode !== null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name: 'organization-contacts', params: { 'wardId': wardId, 'organizationCode': organization.org_code }}">{{organization.org_name}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Modify {{organization.org_name}}</b-breadcrumb-item>
        </b-breadcrumb>
        <h1>Organization/Group: {{organization.org_name}}-({{organization.org_code}})</h1>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    v-if="orgCode === null"
                    id="input-group-1"
                    label="Organization/Group Code:"
                    label-for="input-1"
                    description="Organization/Group Code.">
                    <b-form-input
                        id="input-1"
                        v-model="organization.org_code"
                        type="text"
                        placeholder="Short code organization will use"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-10"
                    label="Organization/Group Name:"
                    label-for="input-10"
                    description="Organization/Group Name.">
                    <b-form-input
                        id="input-1"
                        v-model="organization.org_name"
                        type="text"
                        placeholder="Name of the ward organization/group"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-7"
                    label="Organization/Group Greeting:"
                    label-for="input-2"
                    description="Organization/Group Greeting.">

                <b-input-group>
                    <b-form-input
                        id="input-7"
                        v-model="organization.org_greeting"
                        type="text"
                        placeholder="Organization/Group Greeting"
                     ></b-form-input>
                    <template #append>
                      <b-dropdown text="Contact Fields" variant="info">
                        <b-dropdown-item @click="addFirstName()">First Name i.e. (John)</b-dropdown-item>
                        <b-dropdown-item @click="addLastName()">Last Name i.e. (Doe)</b-dropdown-item>
                        <b-dropdown-item @click="addGender()">Gender i.e. (Brother/Sister)</b-dropdown-item>
                        <b-dropdown-item @click="addTitle()">Title/Calling i.e. (President/Bishop)</b-dropdown-item>
                      </b-dropdown>
                    </template>

                </b-input-group>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="Organization/Group Signature:"
                    label-for="input-2"
                    description="Organization/Group Signature.">
                    <b-form-input
                        id="input-2"
                        v-model="organization.org_signature"
                        type="text"
                        placeholder="Organization/Group Signature"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-6"
                    label="Organization/Group Response Text:"
                    label-for="input-6"
                    description="Text that will be used when contact sends inbound message, default will use greeting">
                    <b-form-input
                        id="input-6"
                        v-model="organization.message_response_text"
                        type="text"
                        placeholder="Thank you for sending a message!"
                    ></b-form-input>
                </b-form-group>
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-5"
                            label="Default Message Language"
                            label-for="input-5"
                            description="Select Language">
                            <b-form-select
                                v-model="organization.greeting_language"
                                :options="availableGreetingLanguageOptions"
                                required
                                ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
        <!-- TODO: needs to be moved out to another component, this will be re-used in a few -->
        <b-form-group label="Additional Message Languages" label-for="tags-component-select">
        <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
        <b-form-tags
          id="tags-component-language-select"
          v-model="organization.message_languages"
          size="lg"
          class="mb-2"
          add-on-change
          no-outer-focus
        >
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                  @remove="removeTag(tag)"
                  :title="tag"
                  :disabled="disabled"
                  variant="info"
                >{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select
              v-bind="inputAttrs"
              v-on="inputHandlers"
              :disabled="disabled || availableLanguageOptions.length === 0"
              :options="availableLanguageOptions"
            >
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose Languages</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
        </b-form-group>
                    </b-col>
                    <b-col>
                        <!-- TODO: needs to be moved out to another component, this will be re-used in a few -->
                        <b-form-group label="Organizations/Groups Included:" label-for="tags-component-select">
                        <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                        <b-form-tags
                          id="tags-component-select"
                          v-model="organization.composite_orgs"
                          size="lg"
                          class="mb-2"
                          add-on-change
                          no-outer-focus
                        >
                          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag
                                  @remove="removeTag(tag)"
                                  :title="tag"
                                  :disabled="disabled"
                                  variant="info"
                                >{{ tag }}</b-form-tag>
                              </li>
                            </ul>
                            <b-form-select
                              v-bind="inputAttrs"
                              v-on="inputHandlers"
                              :disabled="disabled || availableOptions.length === 0"
                              :options="availableOptions"
                            >
                              <template #first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Choose an Organization...</option>
                              </template>
                            </b-form-select>
                          </template>
                        </b-form-tags>
                        </b-form-group>
                    </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                    <b-form-tags
            :tag-validator="emailValidator"
            :input-attrs="{
                'aria-describedby': 'tags-validation-help',
                'aria-label': 'tags-label'
                 }"
            input-id="input-group-6"
            v-model="organization.message_notifications"
            tag-variant="primary"
            tag-pills
            size="medium"
            separator=" ,;"
            placeholder="Enter emails to notify when inbound message received, separate them by comma or semicolon."
            remove-on-delete
            ></b-form-tags>
            <template #invalid-feedback>
              Some of the emails are invalid!
            </template>
            <template #description>
              <div id="tags-validation-help">
                Emails to notify when inbound message received, separate them by comma or semicolon
              </div>
            </template>
            <template #label>
                <div id="tags-label">
                    Notification Emails:
                </div>
            </template>

        </b-form-group>
                </b-col>
            </b-row>
        <b-form-checkbox
            v-model="organization.disabled"
            class="mb-3 mt-3"
            name="check-button" switch>
            Organization/Group Disabled
        </b-form-checkbox>
        <b-form-checkbox
            v-if="orgCode === null"
            v-model="organization.primary"
            name="check-button" switch>
            Primary Organization/Group,
        </b-form-checkbox>

        <b-button type="submit" variant="primary" v-if="orgCode!==null">Update</b-button>
        <b-button type="submit" variant="primary" v-if="orgCode===null">Create</b-button>
            </b-form>

        </b-card>


</b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { organizationMixin } from "@/mixins/organizationMixin";
import handleError from "@/errorHandler";
export default {
    name: "WardOrganization",
    mixins: [organizationMixin],
    props: {
        wardId: {
            type: String,
            required: false
        },
        orgCode: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            options: [],
            primary_options:[],
            language_options:[],
            organization: {
                org_name: null,
                org_code: null,
                org_signature: null,
                composite_orgs: [],
                primary: false,
                greeting_language: null,
                message_response_text: null,
                disabled: false,
                org_greeting: null,
                message_notifications: [],
                message_languages: []
            },
            ward: {
                ward_name: null
            }
        };
    },
    computed: {
      availableOptions() {
        let opts = this.allOrganizations.filter(opt => this.organization.composite_orgs.indexOf(opt.value) === -1 && opt.value !== this.organization.org_code);

        return opts;
      },
      availableLanguageOptions() {
            return this.language_options.filter(opt => this.organization.message_languages.indexOf(opt.value) === -1 && opt.value !== this.organization.greeting_language);
        },
      availableGreetingLanguageOptions() {
            return this.language_options.filter(opt => this.organization.message_languages.indexOf(opt.value) === -1);
      }
    },
    async mounted () {
        if(this.orgCode !== null)
            await this.getOrganization();
        if(this.orgCode !== null || this.orgCode !== '')
            await this.getOrganizations(this.wardId);
        this.language_options = this.$store.state.frontEndSettings.ward_languages;

    },
    methods: {
        addFirstName(){
            if (this.organization.org_greeting===null)
                this.organization.org_greeting = "{first_name}";
            else
                this.organization.org_greeting = this.organization.org_greeting + " " + "{first_name}";
        },
        addLastName(){
            if (this.organization.org_greeting===null)
                this.organization.org_greeting = "{last_name}";
            else
                this.organization.org_greeting = this.organization.org_greeting + " " + "{last_name}";
        },
        addGender(){
            if (this.organization.org_greeting===null)
                this.organization.org_greeting = "{gender}";
            else
                this.organization.org_greeting = this.organization.org_greeting + " " + "{gender}";
        },
        addTitle(){
            if (this.organization.org_greeting==null)
                this.organization.org_greeting = "{title}";
            else
                this.organization.org_greeting = this.organization.org_greeting + " " + "{title}";
        },
        async onSubmit (event) {
            event.preventDefault();
            try{
                if(this.orgCode !== null){
                    await this.updateOrganization();
                }else{
                    await this.createOrganization();
                }
            }catch (e) {
                handleError(e, "Error trying to update organization!");
            }

        },
        async getOrganization() {
            try {
                const { data } = await WardApi.getWardOrganization(this.wardId, this.orgCode);
                this.organization = data.org;
                this.ward = data.ward;
            } catch (e) {
                handleError(e, "Error trying to fetch organization");
            }
        },
        async updateOrganization() {
            try{
                const { data } = await WardApi.updateWardOrganization(this.wardId, this.orgCode, this.organization);
                this.$toast.success("Successfully updated organization");
                await this.$router.push({ name: 'organization-contacts',params: { wardId: this.wardId, organizationCode: this.orgCode}});
            } catch (e) {
                handleError(e, "Error trying to update organization");
            }
        },
        async createOrganization() {
            try{
                const { data } = await WardApi.createWardOrganization(this.wardId, this.organization);
                this.$toast.success("Successfully created organization");
                await this.$router.push({ name: 'organization-contacts',params: { wardId: this.wardId, organizationCode: this.organization.org_code}});
            } catch (e) {
                handleError(e, "Could not create the organization")
            }
        },
        emailValidator(email) {
            // Individual tag validator function
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!email.match(validRegex)) return false

            return true;
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
